import { render, staticRenderFns } from "./CompositionApiComputed.vue?vue&type=template&id=741bf9c2&"
import script from "./CompositionApiComputed.vue?vue&type=script&lang=js&"
export * from "./CompositionApiComputed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports